import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, useDisclosure } from '@heroui/react';
import React, { FC, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import { Editor, GENERATOR_ROUTES } from '../components';
import { ensureFontsLoaded } from '../config/fonts';
import { useAdsGeneratorStore } from '../model/store';
import { EditorViewport, FullBleedEditorStyles } from './EditorPage.styled';

/**
 * Edytor pod własnym adresem. Scena żyje w pamięci, więc wejście tu bez niej
 * (odświeżenie strony, wklejony link) wraca do wyboru formatu zamiast pokazywać
 * pustą planszę.
 */
export const EditorPage: FC = () => {
  const scene = useAdsGeneratorStore((state) => state.scene);
  const closeScene = useAdsGeneratorStore((state) => state.closeScene);
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    ensureFontsLoaded();
  }, []);

  if (!scene) return <Navigate to={GENERATOR_ROUTES.new} replace />;

  const leave = (): void => {
    closeScene();
    navigate(GENERATOR_ROUTES.new);
  };

  // Wyjście kasuje planszę, więc pytamy tylko wtedy, gdy jest co stracić.
  const handleBack = (): void => {
    if (scene.elements.length > 0) onOpen();
    else leave();
  };

  return (
    <EditorViewport data-ads-editor>
      <FullBleedEditorStyles />
      <Editor onBack={handleBack} />

      <Modal isOpen={isOpen} onClose={onClose} size="sm" radius="sm">
        <ModalContent>
          <ModalHeader>Wrócić do wyboru formatu?</ModalHeader>
          <ModalBody>
            <p className="text-sm text-gray-600">
              Bieżąca plansza zostanie wyczyszczona. Jeśli chcesz zachować kreację, najpierw ją zapisz albo pobierz plik.
            </p>
          </ModalBody>
          <ModalFooter>
            <Button size="sm" radius="sm" variant="light" onPress={onClose}>
              Zostaję w edytorze
            </Button>
            <Button
              size="sm"
              radius="sm"
              color="danger"
              onPress={() => {
                onClose();
                leave();
              }}
            >
              Wróć i wyczyść
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </EditorViewport>
  );
};
